<div class="filter-container">
  <form [formGroup]="byStatusForm">
    <div formArrayName="statuses">
      <div
        class="sgc"
        *ngFor="let statusCtrl of statuses.controls; let i = index"
      >
        <single-choice
          [formControl]="statusCtrl"
          (click)="setEditingIndex(i)"
          [completedUrl]="completionUrl"
          [topic]="'status'"
          [editMode]="true"
          [ticketId]="fakeId"
          [icon]="'check_circle'"
          (choiceEvent)="relaySingleChoice($event)"
          [labelOnDemand]="statusLabelerByService"
          [choiceObserver]="statusObserver"
        ></single-choice>
      </div>
    </div>

    <button type="button" class="add-status-btn" (click)="addStatusField()">
      +
    </button>

    <not [filter]="statusFilter" (filterChanged)="onFilterChanged($event)">
    </not>

    <button class="apply-filter-btn" type="submit" (click)="apply()">
      Apply
    </button>
  </form>
</div>
